import { h, Fragment } from 'preact';

type CustomInputProps = {
  name: string;
  placeholder: string;
  label: string;
  type: string;
  validator?: string;
  value?: string;
};

const CustomInput = (props: CustomInputProps) => {
  if (props.label.includes('|')) {
    return (
      <div class="mb-3 form-group">
        {' '}
        <label for={props.name}>
          {props.label.split('|').map((item, index) => {
            return (
              <span style={{ display: 'block' }} key={`${item}-${index}`}>
                {item}
              </span>
            );
          })}
        </label>
        <input
          type={props.type}
          class="form-control input"
          id={props.name}
          name={props.name}
          data-validator={props.validator || ''}
          placeholder={props.placeholder}
          value={props.value}
        />
      </div>
    );
  }
  return (
    <div class="form-floating mb-3 form-group">
      <input
        type={props.type}
        class="form-control input"
        id={props.name}
        name={props.name}
        data-validator={props.validator || ''}
        placeholder={props.placeholder}
        value={props.value}
      />
      <label for={props.name}>{props.label}</label>
    </div>
  );
};

export default CustomInput;
